import $ from 'jquery';
$(document).ready(function () {
  var $eventColumns = $('.js-events-columns');
  if (!$eventColumns.length) { return; }

  var $allEventProfiles = $eventColumns.find('.c-profile-group');
  var $firstEventProfile = $allEventProfiles.first();
  var $eventProfiles = $allEventProfiles.slice(1);
  console.log($eventProfiles);

  var alignProfileGroups = function() {
    var firstPosition = $firstEventProfile.position().top;
    $eventProfiles.removeClass('column-shift').each(function(_, profile) {
      var profilePosition = $(profile).position().top;
      if (profilePosition === firstPosition) {
        $(profile).addClass('column-shift');
      }
    });
  };

  $(window).resize($.throttle(100, alignProfileGroups)).trigger('resize');
});
